const firebaseConfig = {
    apiKey: "AIzaSyDvmPMDrdN2inHD8GDwc3E3LkBvMCNGF3A",
    authDomain: "full-stack-21449.firebaseapp.com",
    projectId: "full-stack-21449",
    storageBucket: "full-stack-21449.appspot.com",
    messagingSenderId: "619675082862",
    appId: "1:619675082862:web:754d3b5351c7b1996e467f"
  };

 export default firebaseConfig;